import React, { useState } from 'react';
import { Card, CardContent, Grid, Alert, Radio, Checkbox, FormControl, RadioGroup, FormControlLabel, SelectField, Option, Typography, 
        FormHelperText, FormLabel, FormGroup, TextField, TableContainer,Table, TableHead, TableBody, TableCell, TableRow, Box } from "@deere/fuel-react"
import { findAnswerIndex, getTranslation, getLDTranslation, findSelectionIndex, containsCheckBoxAnswer, getRequestStatusWhenCampaignClosed } from '../../utils/utils';
import { useTranslation } from "react-i18next";
import "../../assets/css/Sections.css";
import FuelTable from "../../components/FuelTable";
import LinearProgressIndicator from "../../components/LineProgressIndicator";
import { PartsTable } from "../../components/tps/PartsTable";
import { SuppliersTable } from '../../components/tps/SuppliersTable';
import { Agreements } from '../../components/tps/Agreements';
import useTpsContext from '../../hooks/useTpsContext';
import {
    EMPTY_BODY, SECTION_TYPES,
    TPS_COMPONENT_CODE_SECTIONS,
    DEFAULT_GRID_COLLUMNS,
    TPSMEX_COMPONENT_CODE_SECTIONS,
    TPS,
    TPSMEX
} from '../../utils/surveyLiterals'
import { getValidator } from '../../utils/validationRequiredFactory'
import "../../assets/css/TpsStyles.css";
import { showInputTextErorr, showTablesError } from '../../utils/validation';
import { TPSModal } from '../../components/tps/TPSModal';
import TpsmexImportExport from '../../components/tpsmex/TpsmexImportExport';
import { PartsTableTPSMEX } from '../../components/tpsmex/PartsTableTPSMEX';

function shouldRender(question, answers, review, questions) {
    let shouldRender = true;
    if (review) { return shouldRender }
    if (question.idQuestionDepends !== null && question.idSelectionDependson !== null) {
        shouldRender = false;
        let answerQuestion = answers ? answers.find(ans => parseInt(ans.questionId) === parseInt(question.idQuestionDepends)) : null;
        if (question.regexp === "notdepends") {
            if (answerQuestion && answerQuestion.answer && !answerQuestion.answer.toString().includes(question.idSelectionDependson.toString())) {
                shouldRender = true;
            }
        } else {
            if (answerQuestion && answerQuestion.value && answerQuestion.value.toString() === question.idSelectionDependson.toString())
                shouldRender = true;

            if (answerQuestion && answerQuestion.answer && answerQuestion.answer.toString() === question.idSelectionDependson.toString())
                shouldRender = true;

            if (shouldRender === true) {
                // Validating grand parent question
                let parentQuestion = questions.find(ques => parseInt(ques.id) === parseInt(question.idQuestionDepends));
                if (parentQuestion && parentQuestion.idQuestionDepends !== null && parentQuestion.idSelectionDependson !== null) {
                    let answerQuestionParent = answers.find(ans => parseInt(ans.questionId) === parseInt(parentQuestion.idQuestionDepends));
                    if (!answerQuestionParent || answerQuestionParent.answer.toString() !== parentQuestion.idSelectionDependson.toString()) {
                        shouldRender = false;
                    }
                }
            }
        }
    }

    return shouldRender;
}

export default function Section({ survey, section, review, questionsToValidate, campaign, countryList, agreements, isSubmit, setIsSubmitted, tpsResponses, resetForm, opcSelected, agreementQuestionIds, selectionModel, setSelectionModel, editedPartCountries, setEditedPartCountries }) {
    const { t } = useTranslation();
    const headers = ['',t('lbl_response_section_column_name'),
                    t('lbl_response_section_column_parts_dec'),
                    t('lbl_response_section_column_date'),
                    t('lbl_response_section_column_updated_by'),
                    t('lbl_response_section_column_status'),''] 
    const questions = section.questions.filter(qu => qu.active).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
    const requiredValidator = getValidator(survey.code);
    const useTps = useTpsContext();
    const answers = Array.isArray(useTps.answers) ? useTps.answers : [];
    const [currentAns, setCurrentAns] = useState(answers);
    const suppliersTable = Array.isArray(useTps.suppliers) ? useTps.suppliers : [];
    const partsData = Array.isArray(useTps.parts) ? useTps.parts : [];
    const responseName = useTps.responseName ? useTps.responseName : '';
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState(null);
    let handleModalAction;
    
    if (!section)
        return EMPTY_BODY;


    const showSelectionModal= (questionSelections, value) =>{
        if(questionSelections){
            let selectionIdx = value !== "" && value ? findSelectionIndex(value, questionSelections) : -1;
            let selection = selectionIdx >= 0 ? questionSelections[selectionIdx] : null
            if(selection && selection.popupKey){
                setModalMessage(t(`${selection.popupKey}`))
                handleModalAction = () => setShowModal(false);
                setShowModal(true);
            }
        }
    }

    const updateAnswer = (e, questionId, isCountry, questionSelections) => {
        setIsSubmitted(false);
        useTps.pushAnswer(questionId, e.target ? e.target.value : e, isCountry, agreementQuestionIds);
        setCurrentAns(answers);
        showSelectionModal(questionSelections, e.target ? e.target.value : e);      
    }   
    const updateCheckAnswer = (e, question) => {
        setIsSubmitted(false);
        let questionIndex = findAnswerIndex(question.id, answers);
        questionIndex >= 0 ? useTps.popAnswer(question.id) : useTps.pushAnswer(question.id, e.target ? e.target.value : null)
        setCurrentAns(true);
    }


    function createRadioSection(question) {
        let indx = findAnswerIndex(question.id, answers);
        let answer = indx >= 0 ? answers[indx].answer : -1;
        let selectionIdx = answer !== "" && answer ? findSelectionIndex(answer, question.selections) : -1;
        let selection = selectionIdx >= 0 ? question.selections[selectionIdx] : null
        let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false; 
        let questionSelections = question.selections;
        
        return shouldRender(question, answers, review, questions) && <FormControl fullWidth>
                {
                    review ?
                        <Box key={`b-${question.id}`}>
                            <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} paddingLeft={question.idQuestionDepends ? '1.5rem':''} fontWeight="semibold" >
                                {getTranslation(question, 'text')}
                            </Typography>
                            <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`} paddingLeft={question.idQuestionDepends ? '1.5rem':''}>
                                {selection !== null ? getTranslation(selection, 'text') : ''}
                            </Typography>
                        </Box>
                        : <FormControl sx={{ m: 3 }}  variant="standard" error={isError} >
                            <FormLabel>
                                <Typography size="sm" component="p" gutterBottom key={`${question.questionId}`} fontWeight="semibold">
                                    {getTranslation(question, 'text')}
                                </Typography>
                            </FormLabel>
                            <RadioGroup name={`radioGroup-${question.id}`} id={`radioGroup-${question.id}`} row  required>
                                {question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                                    i.active ? <FormControlLabel
                                        sx={{
                                            paddingLeft: question.idQuestionDepends ? 4 : 0,
                                            alignItems: 'start',
                                            "& .MuiStack-root": {
                                                display: "flex",
                                                flexDirection: "row",
                                            }
                                        }}
                                        control={<Radio required={required !== undefined && required !== null ? required : question.required}/>}
                                        value={i.value}
                                        id={i.id}
                                        key={i.id}
                                        label={<FormHelperText><Typography paragraph sx={{ textAlign: 'justify', whiteSpace: 'pre-wrap' }}>{getTranslation(i, 'text')}</Typography></FormHelperText>}
                                        name={`${getTranslation(section, 'description')}-${question.id}`}
                                        onChange={(e) => updateAnswer(e, question.id, false, questionSelections)} data-testid={i.id}
                                        checked={indx >= 0 && answer && answer === i.value} />
                                        : ''
                                )}
                            </RadioGroup>
                                {
                                    isError ? <FormHelperText>{ t('bs_required')} </FormHelperText> : null
                                }
                            </FormControl>
                }
        </FormControl>
    }

    function createCheckSection(question) {
        let indx = findAnswerIndex(question.id, answers);
        let answer = indx >= 0 ? answers[indx].answer : ''
        let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;

        return shouldRender(question, answers, review, questions) && <>
            <Typography size="sm" component="p" gutterBottom fontWeight="semibold" key={`q${question.questionId}`}>
                {getTranslation(question, 'text')}
            </Typography>
            {
                <div id={question.questionId}>
                    <>
                        {
                            review ?
                                question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                                    (i.active && answer === i.value.toString()) ?
                                        <div key={i.id}>
                                            <Typography size="sm" component="p" gutterBottom key={i.id}> {i !== null ? getTranslation(i, 'text') : ''}</Typography>
                                            <br />
                                        </div>
                                        : ''
                                )
                                : question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                                    (i.active) ?
                                        <FormControl 
                                        error={isError}>
                                            <FormLabel></FormLabel>
                                            <FormGroup required={required !== undefined && required !== null ? required : question.required} error={isError}>
                                                <FormControlLabel
                                                    control={<Checkbox name={`${getTranslation(section, 'description')}-${question.id}`} />}
                                                    sx={{
                                                        alignItems: 'start'
                                                       }}
                                                    value={i.value}
                                                    id={i.id}
                                                    key={i.id}
                                                    label={getTranslation(i, 'text')}
                                                    name={`${getTranslation(section, 'description')}-${question.id}`}
                                                    onChange={(e) => updateCheckAnswer(e, question, i.exclusive)}
                                                    data-testid={i.id}
                                                    checked={containsCheckBoxAnswer(i.value, answer)}
                                                />
                                            </FormGroup>
                                            {
                                                isError ? <FormHelperText> {t('bs_required')}</FormHelperText> : null
                                            }
                                        </FormControl>
                                        
                                        : ''

                                )
                        }
                    </>
                </div>
            }
        </>
    }

    function createTextArea(question) {
        let indx = findAnswerIndex(question.id, answers);
        let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;
        return shouldRender(question, answers, review, questions) && <>
            {
                review ? 
                    <div key={question.questionId}>
                        <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} fontWeight="semibold">
                            {getTranslation(question, 'text')}
                        </Typography>
                        <Typography className="tpsmexaddress" size="sm" component="p" gutterBottom key={question.questionId}>{indx >= 0 ? answers[indx].answer : ''}</Typography>
                    </div>
                    :
                        <TextField 
                            required={required !== undefined && required !== null ? required : question.required}
                            onChange={(e) => updateAnswer(e, question.id)}
                            value={indx >= 0 ? answers[indx].answer : ''}
                            name={`${getTranslation(section, 'description')}-${question.id}`}
                            error={isError} 
                            variant="outlined" 
                            helperText={isError ? t('bs_required') : ''}
                            label={getTranslation(question, 'text')}
                            type="text"
                            multiline
                            minRows={7}
                        />
            }
        </>
    }


    function createInput(question) {
        let required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        let indx = findAnswerIndex(question.id, answers);
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;
        return shouldRender(question, answers, review, questions) && <>
            {
                review ?
                    <>
                        <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} fontWeight="semibold">
                            {getTranslation(question, 'text')}
                        </Typography>
                        <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`}>
                            {indx >= 0 ? answers[indx].answer : ''}
                        </Typography>
                    </>
                    :
                    <>
                        <TextField 
                            required={required !== undefined && required !== null ? required : question.required}
                            onChange={(e) => updateAnswer(e, question.id)}
                            value={indx >= 0 ? answers[indx].answer : ''}
                            name={`${getTranslation(section, 'description')}-${question.id}`}
                            error={isError} 
                            variant="outlined" 
                            helperText={isError ? t('bs_required') : ''}
                            label={getTranslation(question, 'text')}/>
                    </>
            }
        </> 
    }

    function createInputName() {
        const required = review ? false : true;
        const name= responseName? responseName : null;
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? !responseName && responseName.length<=0 : false; 
        return <>
            {
                review ?
                    <>
                        <Typography size="sm" component="p" gutterBottom key={`lbl-${t('tps_lbl_survey_response_name')}`} fontWeight="semibold">
                            {t('tps_lbl_survey_response_name')}
                        </Typography>
                        <Typography size="sm" component="p" gutterBottom key={t('tps_lbl_survey_response_name')}>
                            {name ? name : ''}
                        </Typography>
                    </>
                    : <>
                    <TextField 
                        required={required}
                        onChange={(e) => useTps.pushResponseName(e.target.value)}
                        value={name ? name : ''}
                        name={`${getTranslation(section, 'description')}-`}
                        error={isError} 
                        variant="outlined" 
                        helperText={isError ? t('bs_required') : ''}
                        label= {t('tps_lbl_survey_response_name')}
                        key={t('tps_lbl_survey_response_name')}
                    />
                    
                </>             
            }
        </> 
    }

    function createDateSection(question) {
        const required = review ? false : requiredValidator(question, section, answers, questionsToValidate);
        const indx = findAnswerIndex(question.id, answers);
        const answer = indx >= 0 ? answers[indx].answer : null;
        const isError = (typeof isSubmit === 'boolean' && isSubmit) ?  showInputTextErorr(answers, question.id) : false;

        return shouldRender(question, answers, review, questions) && <>
                {review ?
                    answer && <>
                        <Typography size="sm" component="p" gutterBottom key={`q${question.questionId}`} fontWeight="semibold">
                            {getTranslation(question, 'text')}
                        </Typography>
                        <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`}>
                            {answer ? answer : ''}
                        </Typography>
                    </>
                    : <>
                        <TextField 
                            required={required !== undefined && required !== null ? required : question.required}
                            onChange={(e) => updateAnswer(e, question.id)}
                            value={answer ? answer : ""}
                            name={`${getTranslation(section, 'description')}-${question.id}`}
                            error={isError} 
                            variant="outlined" 
                            helperText={isError ? t('bs_required') : ''}
                            label={getTranslation(question, 'text')}
                            type="date"
                        />
                    </>
                }
            </>
    }

    function createCountrySection(question) {
        if (!countryList)
            return (<span>{t('tps_country_not_found')}</span>);
        if (countryList.length > 0) {
            const indx = findAnswerIndex(question.id, answers);
            const answer = indx >= 0 ? answers[indx].answer : -1;
            const country = answer? countryList.find(c => c.iso2CountryCode === answer.toString()) : null;
            
            let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;
            return (     
                review ? <>
                        <Typography size="sm" component="p" gutterBottom key={`a${question.questionId}`} fontWeight="semibold">{getTranslation(question, 'text')}</Typography>
                        <Typography size="sm" component="p" gutterBottom key={`l${question.questionId}`}>{country ? country.name : ''}</Typography>
                    </>
                    :
                     <FormControl sx={{ m: 3 }} error={isError} variant="standard">
                        <SelectField
                            error={isError}
                            fullWidth={false}
                            id={`${getTranslation(section, 'description')}-${question.id}`}
                            label={getTranslation(question, 'text')}
                            key="originCountry"
                            required    
                            size="small"
                            value={answer < 0?'':answer}
                            onChange={(e) => { updateAnswer(e.target.value, question.id, true); }
                            }
                        >
                            <Option disabled hidden value="">{t('lbl_dropdown_select')}</Option>
                            {countryList ? countryList.map(opt => <Option key={opt.iso2CountryCode} value={opt.iso2CountryCode}>{opt.name}</Option>) : null}
                        </SelectField>
                            {
                                isError ? <FormHelperText> {t('bs_required')}</FormHelperText> : null
                            }
                    </FormControl>
            );
        }
        else {
            return (
                <span>{t('tps_country_not_found')}</span>
            );
        }
    }

    function createOptionSection(question) {
        let indx = findAnswerIndex(question.id, answers);
        let answer = indx >= 0 ? answers[indx].answer : -1
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showInputTextErorr(answers, question.id) : false;

        return shouldRender(question, answers, review, questions) && 
                    review ?
                        question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                            (i.active && answer === i.value.toString()) ?
                                <Box key={`box-${question.id}`}>
                                    <Typography size="sm" component="p" gutterBottom key={`q${question.id}`} fontWeight="semibold">
                                        {getTranslation(question, 'text')}
                                    </Typography>
                                    <Typography size="sm" component="p" gutterBottom key={`a${i.id}`}>
                                        {i !== null ? getTranslation(i, 'text') : ''}
                                    </Typography>
                                </Box>
                            : ''
                        )
                        :
                        <FormControl sx={{ m: 3 }} error={isError} variant="standard">
                            <SelectField
                                required
                                error={isError}
                                fullWidth={false}
                                label={getTranslation(question, 'text')}
                                id={`${getTranslation(section, 'description')}-${question.id}`}
                                key={`option${question.id}`}
                                value={answer < 0?'':answer}
                                onChange={(e) => { updateAnswer(e, question.id); }}>
                                <Option disabled hidden value="">{t('lbl_dropdown_select')}</Option>
                                {question.selections.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((i) =>
                                    (i.active) ?
                                        <Option key={`${i.id}`} selected={indx >= 0 && answer && answer === i.value} value={i.value}>{getTranslation(i, 'text')}</Option>
                                        : ''
                                )
                                }
                            </SelectField>
                                {
                                    isError ? <FormHelperText> {t('bs_required')}</FormHelperText> : null
                                }
                        </FormControl>        
                
    }
      
    function renderParts(){  
        let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showTablesError(suppliersTable, partsData, true, survey.code) : false;
        const tmpParts = [];
        if (review && useTps && useTps.parts) {
            useTps.parts.forEach((part) => {
              let index = tmpParts.findIndex((i) => i.id === part.id);
              if (index === -1) tmpParts.push(part);
              else tmpParts[index] = {...tmpParts[index], country: tmpParts[index].country+", "+part.country};
            });
          }
        return review && tmpParts ?
            <Grid item md={12}>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('parts_tbl_column_header_1')}</TableCell>
                                <TableCell>{t('parts_tbl_column_header_2')}</TableCell>
                                <TableCell>{t('parts_tbl_column_header_3')}</TableCell>
                                <TableCell>{t('parts_tbl_column_header_4')}</TableCell>
                                {survey && survey.code && survey.code === TPSMEX && (
                                    <>
                                        <TableCell>{t("parts_tbl_column_header_7")}</TableCell>
                                        <TableCell>{t("parts_tbl_column_header_6")}</TableCell>
                                    </>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                            tmpParts.map((row)=>
                                <TableRow key={`rp-${row.id}`}>
                                    <TableCell align="left">{row.supplierNumber}</TableCell>
                                    <TableCell align="left">{row.deerePartNumber}</TableCell>
                                    <TableCell align="left">{row.deerePartDesc}</TableCell>
                                    <TableCell align="left">{row.hsCode}</TableCell>
                                    {survey && survey.code && survey.code === TPSMEX && (
                                        <> 
                                            <TableCell align="left">{row.originCriterion}<br/>{row.comments}</TableCell>
                                            <TableCell align="left">{row.country}</TableCell>
                                        </>
                                )}
                                </TableRow>
                            )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        :
            <>
                <Grid item xs={6} md={12}>
                    {survey.code === TPS ? (
                        <PartsTable campaign={campaign} partsSelected={useTps.parts} survey={survey}/>
                    ) : (
                        <PartsTableTPSMEX
                            campaign={campaign}
                            partsInResponse={useTps.parts}
                            selectionModel={selectionModel}
                            setSelectionModel={setSelectionModel}
                            editedPartCountries={editedPartCountries}
                            setEditedPartCountries={setEditedPartCountries}
                            survey={survey}
                            setIsSubmitted={setIsSubmitted}
                        />
                    )}
                </Grid>
                <Grid item xs={6} md={12}>
                    {
                        isError ? <Alert variant={"error"}> {t('bs_required')}</Alert> : null
                    }
                </Grid>
            </>
    }

    function getCollumnsByQuestion(questions, questionsGroup) {
        const questionsInGroup = questions.filter(q => q.questionsGroup === questionsGroup);
        return questionsInGroup ? (DEFAULT_GRID_COLLUMNS / questionsInGroup.length) : DEFAULT_GRID_COLLUMNS;
    }
    
    const questionsComponents = questions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1).map((q) => {
        
        const collumnsByQuestion = q.questionsGroup ? getCollumnsByQuestion(questions, q.questionsGroup) : DEFAULT_GRID_COLLUMNS;
        return <Grid key={`gq-${q.id}`} item md={collumnsByQuestion} >
             <div style={{ padding: 10, paddingLeft: q.idQuestionDepends ? '1.5rem' : 10 , paddingTop:6, paddingBottom:7}}>
                {q.type === 'RADIO' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                {q.type === 'CHECK' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCheckSection(q) : <></>}
                {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createTextArea(q) : <></>}
                {q.type === 'OPEN_SMALL' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createInput(q) : <></>}
                {q.type === 'DATE' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createDateSection(q) : <></>}
                {q.type === 'OPTION_CTY' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCountrySection(q) : <></>}
                {q.type === 'OPTION' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createOptionSection(q) : <></>}
            </div>
        </Grid>
    });

    function renderSupplier(){
       let isError = (typeof isSubmit === 'boolean' && isSubmit) ? showTablesError(suppliersTable, partsData, false) : false;
       const tmpAssignments = review && useTps ? useTps.assignments : null;
       return review ?
            <>
                <Grid item xs={6} md={4} sx={{ paddingBottom:"12px",paddingLeft: "10px" }}>
                    {createInputName()}
                </Grid>
                <Grid item md={12}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{'Supplier'}</TableCell>
                                    <TableCell>{'Supplier Name'}</TableCell>
                                    <TableCell>{'Request Number'}</TableCell>
                                    <TableCell>{'Status'}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                tmpAssignments? tmpAssignments.map((row)=>
                                        <TableRow key={`rp-${row.id}`}>
                                            <TableCell align="left">{row.supplierNumber}</TableCell>
                                            <TableCell align="left">{row.supplierName}</TableCell>
                                            <TableCell align="left">{row.id}</TableCell>
                                            <TableCell align="left">{campaign ? getRequestStatusWhenCampaignClosed(row.status, campaign.status) : ""}</TableCell>
                                        </TableRow>
                                    )
                                    : ''
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </>
        : <>
            <Grid item xs={6} md={4} sx={{ paddingBottom:"12px",paddingLeft: "10px" }}>
                {createInputName()}
            </Grid>
            <Grid item xs={6} md={12}> 
                <SuppliersTable campaign={campaign} suppliers={useTps.suppliers}/> 
            </Grid>
            <Grid item xs={6} md={12}>
                {
                    isError ? <Alert variant={"error"}> {t('bs_required')}</Alert> : null
                }
            </Grid>
        </> 
    }

    function renderResponseSection(){  
        if(tpsResponses){
            return  <Grid item xs={6} md={12}>
                        <RadioGroup name="selectedCustom" value={opcSelected}><FuelTable headers={headers} data={tpsResponses?tpsResponses : []} resetForm={resetForm}/></RadioGroup>
                    </Grid>; 
        }else{
            return  <Grid item xs={6} md={12}>
                        <LinearProgressIndicator title='Loading responses' subtitle='This will take a couple of seconds'/>
                    </Grid>
        }
    }

    function renderAgreements(){
        return <Agreements agreements={agreements} questions={questions} createRadio={createRadioSection} review={review?review:null} answers={answers} />
    }

    function renderImporterExporter() {
        return <TpsmexImportExport questions={questions} getCollumnsByQuestion={getCollumnsByQuestion} createRadioSection={createRadioSection} createDateSection={createDateSection} createInput={createInput} createTextArea={createTextArea}/>
      }

    function shouldDisplay(section){  
        if(TPS_COMPONENT_CODE_SECTIONS.RESPONSES_SEC !== section.code && TPSMEX_COMPONENT_CODE_SECTIONS.RESPONSES_SEC !== section.code){
            return true;
        };
        if(Array.isArray(tpsResponses) && tpsResponses.length>0){
            return true;
        }else{
            return false;
        }
    }

    function renderSection(section) {
        if ((section.type && SECTION_TYPES.includes(section.type.trim().toUpperCase())) || 
            TPS_COMPONENT_CODE_SECTIONS.AGREEMENT_SEC === section.code || 
            TPS_COMPONENT_CODE_SECTIONS.RESPONSES_SEC === section.code ||
            TPSMEX_COMPONENT_CODE_SECTIONS.RESPONSES_SEC === section.code) {
            switch (section.code) {
                case TPSMEX_COMPONENT_CODE_SECTIONS.SUPPLIERS_SEC:
                case TPS_COMPONENT_CODE_SECTIONS.SUPPLIERS_SEC:
                    return renderSupplier();
                case TPSMEX_COMPONENT_CODE_SECTIONS.PARTS_SECTIONS:
                case TPS_COMPONENT_CODE_SECTIONS.PARTS_SECTIONS:
                    return renderParts();
                case TPSMEX_COMPONENT_CODE_SECTIONS.RESPONSES_SEC:
                case TPS_COMPONENT_CODE_SECTIONS.RESPONSES_SEC:
                    return renderResponseSection();
                case TPS_COMPONENT_CODE_SECTIONS.AGREEMENT_SEC:
                    return renderAgreements();
                case TPSMEX_COMPONENT_CODE_SECTIONS.IMPORTER_EXPORTER_SEC:
                    return renderImporterExporter();
                default: 
                    return null;
            }
        }
        return questionsComponents;
    }

    return shouldDisplay(section)?
        <>
             <Card>
                <CardContent id={section ? section.description : ''} >
                    <Typography gutterBottom variant="h2">
                        {getTranslation(section, 'description')}
                    </Typography>
                    <Typography gutterBottom variant="subtitle1" >{getLDTranslation(section, 'longDescription')}</Typography>
                    <Grid container>
                        {
                            renderSection(section)
                        }
                        {
                            showModal ? 
                            <>
                                <TPSModal showModal={showModal}
                                    setShowModal ={setShowModal} 
                                    labelBtnPrimary={t('btn_close')}
                                    handleSubmit={handleModalAction}
                                    modalMessage={modalMessage}
                                    titleModal={t('tps_lbl_caution')}
                                />
                            </>
                            : null
                        }
                       
                    </Grid>
                </CardContent>
            </Card>
            <br/>
        </>:''
}
